'use strict';

(function (window, $) {
    var $searchForm = $('#jwsdw-pressRelease-searchForm'),
        $searchInput = $('#jwsdw-pressRelease-search input'),
        $year = $('#jwsdw-pressRelease-year'),
        $searchButton = $('#jwsdw-pressRelease-search button'),
        $pressReleaseTemplate = $('.jwsdw-pressRelease-article-template'),
        $noResultsTemplate = $('.jwsdw-pressRelease-noResults-template'),
        state = {
            'q': $searchInput.val(),
            'year': $year.val(),
            'tab': $('input[name=tabgroup]:checked').val()
        },
        $showMore = $('.jwsdw-pressRelease-showMore');

    $searchForm.on('submit', search);
    $searchInput.on('keyup', window.jwsdwUtil.debounce(650, search));
    $searchButton.on('click', search);

    $year.on('change', search);

    $showMore.on('click', function () {
        var $button = $(this),
            $section = $button.parents('.jwsdw-pressRelease-section'),
            $hiddenArticles = $section.find('.jwsdw-pressRelease-article.jws-hidden'),
            i;

        for (i = 5; i >= 0; i--) {
            $($hiddenArticles[i]).removeClass('jws-hidden');
        }

        if ($section.find('.jwsdw-pressRelease-article.jws-hidden').length === 0) {
            $button.addClass('jws-hidden');
        }
    });

    $(window).on('popstate', function () {
        if (window.history.state) {
            state = window.history.state;
            $searchInput.val(state.q);
            $year.val(state.year);
            if (state.tab) {
                $('input[value="' + state.tab + '"]').prop('checked', true);
            }
            search(null, true);
        }
    });

    $(document).on('click', '.jwsdw-tabs-nav .jwsdw-tabs-nav-item-button', function() {
        state.tab = document.getElementById(this.getAttribute('for')).value;
        window.history.pushState(state, $(document).find('title').text(), buildUrlParameters(state));
    });

    /**
     * @description Method to perform search request
     * @param {Object} e event object
     * @param {Boolean} popState true if triggered by popState
     * @return {void}
     */
    function search (e, popState) {
        var url = $searchForm.attr('action');

        if (e) {
            e.preventDefault();
        }
        state.q = $searchInput.val();
        state.year = $year.val();
        url = buildUrlParameters(state);
        if (!popState) {
            window.history.pushState(state, $(document).find('title').text(), url);
        }
        $.ajax({
            'type': 'GET',
            'format':'ajax',
            'url': url,
            'data': {
                'isAjax': true
            },
            'beforeSend': function() {
                $searchButton.find('.jwsdw-spinner').removeClass('jws-hidden');
                $searchButton.find('svg').addClass('jws-hidden');
            },
            /**
             * @function
             * @param {Object} response response
             * @param {Object} response.productReleases product releases
             * @param {Object} response.corporateReleases product releases
             * @returns {void} true
             */
            'success': function(response) {
                response.categories.map(function(category) {
                    var $navItem = $('#jwsdw-pressRelease-nav-' + category.id),
                        $section = $('#jwsdw-pressRelease-' + category.id),
                        $noResults;

                    $section.find('.jwsdw-pressRelease-article, .jwsdw-pressRelease-noResults').remove();
                    if (category.releases.length > 0) {
                        $navItem.removeClass('jws-opacity-50');
                        category.releases.map(function(pressRelease, index) {
                            var $pressRelease = $pressReleaseTemplate.clone();

                            $pressRelease.find('a').attr('href', pressRelease.url);
                            $pressRelease.find('img').attr('src', pressRelease.image);
                            $pressRelease.find('.jwsdw-pressRelease-date').text(pressRelease.date);
                            $pressRelease.find('.jwsdw-pressRelease-title').text(pressRelease.title);
                            $pressRelease.find('.jwsdw-pressRelease-excerpt').text(pressRelease.excerpt);
                            if (index < 6) {
                                $pressRelease.removeClass('jws-hidden');
                            }
                            $section.append($pressRelease);
                        });
                    } else {
                        $noResults = $noResultsTemplate.clone();
                        $noResults.removeClass('jws-hidden');
                        $section.append($noResults);
                        $navItem.addClass('jws-opacity-50');
                    }
                    if (category.releases.length > 6) {
                        $section.find('.jwsdw-pressRelease-showMore').removeClass('jws-hidden');
                    } else {
                        $section.find('.jwsdw-pressRelease-showMore').addClass('jws-hidden');
                    }

                    $section.find('.jwsdw-pressRelease-showMore').parent().detach().appendTo($section);
                });
            },
            'complete': function() {
                $searchButton.find('.jwsdw-spinner').addClass('jws-hidden');
                $searchButton.find('svg').removeClass('jws-hidden');
            }
        });
    }

    /**
     * @description Method to build Url Parameters from obj
     * @param {Object} obj the object
     * @returns {String} url with url parameters
     */
    function buildUrlParameters(obj) {
        var url = '',
            params = [];

        params = Object.keys(obj)
            .filter(function(key) {
                return obj[key];
            })
            .sort(function(a, b) {
                return a > b ? 1 : -1;
            })
            .map(function(key) {
                return key + '=' + obj[key];
            });
        if (params.length > 0) {
            url = '?' + params.join('&');
        }
        return url;
    }
}(window, jQuery));